import {useI18n} from "vue-i18n";

const pad = (n) => String(n).padStart(2, '0')

const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

// all in the viewer's time zone; toISOString() used to shift late calls to
// the next or previous day
export default function useCallDate() {
    const {t: $t} = useI18n()

    // the API sends UTC without a zone ("2026-10-30 20:48:40"); read as is, it
    // was taken for local time and showed the server's clock
    const toDate = (value) => {
        if (!value) return null

        const isZoneless = typeof value === 'string' && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value)
        const date = new Date(isZoneless ? `${value.replace(' ', 'T')}Z` : value)
        return isNaN(date) ? null : date
    }

    // 2026-10-12, as the table always showed it
    const formatDate = (value) => {
        const date = toDate(value)
        return date ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` : ''
    }

    const formatTime = (value) => {
        const date = toDate(value)
        return date ? `${pad(date.getHours())}:${pad(date.getMinutes())}` : ''
    }

    // "Today" and "Yesterday" while the call is recent, 10.10 after that
    const formatDay = (value) => {
        const date = toDate(value)
        if (!date) return ''

        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)

        if (sameDay(date, today)) return $t('telephony.calls_history.today')
        if (sameDay(date, yesterday)) return $t('telephony.calls_history.yesterday')

        return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}`
    }

    // call_380671112233_2026-10-30_14-32, the extension comes from the file
    const recordName = (item) =>
        `call_${item.contact}_${formatDate(item.datetime)}_${formatTime(item.datetime).replace(':', '-')}`

    return {formatDate, formatTime, formatDay, recordName}
}
